import { useAuthenticationStore } from '../stores/authentication';
import { storeToRefs } from 'pinia';

/**
 * Gives the account information of the current account.
 */
export function useAuthentication() {
    return storeToRefs(useAuthenticationStore());
}
